import React from "react";
import useMobile from "../../../hooks/useMobile";
import useTab from "../../../hooks/useTab";

const Notice = () => {
  const mobile = useMobile();
  const tab = useTab();
  return (
    <section
      className="quality-work"
      style={{
        padding: "0px 0px 20px 0px",
        // marginTop: (!mobile && !tab) ? "88px" : "unset",
        marginLeft: !mobile && !tab ? "240px" : "unset",
      }}
    >
      <div className="container">
        <div
          className="section-title custom-text-center"
          style={{ marginBottom: "10px" }}
        >
          <h2 className="section-title__title custom-user-section-title">
            Notice
          </h2>
        </div>
        <div className="row">
          <div
            className="col-xl-12"
            style={{ marginTop: mobile || tab ? "10px" : "unset" }}
          >
            <div className="quality-work__tab-box tabs-box">
              <div
                className="donation-details__presentation custom-feature-two__single"
                style={{ padding: "0px", backgroundColor: "transparent" }}
              >
                <div className="admin-notice">
                  <h3 className="admin-notice__title">Admin Notice</h3>
                  <hr />
                  <div className="admin-notice__box">
                    <span>No notifications</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Notice;
